import React, { useState } from 'react';
import { SafeAreaView, KeyboardAvoidingView, StyleSheet, Platform, View } from 'react-native';
import { Text, Input, CheckBox, Button } from 'react-native-elements';
import { FailureToast, SuccessToast } from '../utils';
import Firebase from '../components/FirebaseContext';

type FeedbackType = 'Suggestion' | 'Complaint' | 'General';

export default function Feedback(): JSX.Element {
	const firestore = Firebase.firestore();
	const [loading, setLoading] = useState(false);
	const [feedbackType, setFeedbackType] = useState<FeedbackType>('Suggestion');
	const [name, setName] = useState('');
	const [phone, setPhone] = useState('');
	const [message, setMessage] = useState('');

	const resetForm = () => {
		setFeedbackType('Suggestion');
		setName('');
		setPhone('');
		setMessage('');
	};

	return (
		<KeyboardAvoidingView behavior={Platform.OS == 'ios' ? 'padding' : 'height'} style={{ flex: 1 }}>
			<SafeAreaView style={{ flex: 1, backgroundColor: '#fff' }}>
				<View style={styles.inner}>
					<Text style={{ fontWeight: '700', fontSize: 16, marginBottom: 20, textAlign: 'center' }}>
						Submit Feedback
					</Text>
					<Input
						placeholder="Name"
						value={name}
						onChangeText={(text) => {
							setName(text);
						}}
					/>
					<Input
						placeholder="Phone"
						value={phone}
						onChangeText={(text) => {
							setPhone(text);
						}}
						keyboardType="phone-pad"
					/>
					<CheckBox
						title="Suggestion"
						checked={feedbackType === 'Suggestion'}
						containerStyle={styles.checkbox}
						onPress={() => {
							setFeedbackType('Suggestion');
						}}
					/>
					<CheckBox
						title="Complaint"
						checked={feedbackType === 'Complaint'}
						containerStyle={styles.checkbox}
						onPress={() => {
							setFeedbackType('Complaint');
						}}
					/>
					<CheckBox
						title="General"
						checked={feedbackType === 'General'}
						containerStyle={styles.checkbox}
						onPress={() => {
							setFeedbackType('General');
						}}
					/>
					<Input
						placeholder="Message"
						value={message}
						onChangeText={(text) => {
							setMessage(text);
						}}
						multiline={true}
						numberOfLines={5}
						containerStyle={{ maxHeight: 200 }}
					/>
					<Button
						title="Submit Feedback"
						buttonStyle={{ backgroundColor: '#275036', paddingVertical: 12 }}
						onPress={async () => {
							if (name.length < 1) {
								FailureToast('Your name is required');
								return;
							}
							if (phone.length < 10) {
								FailureToast('Please enter a correct phone number');
								return;
							}
							if (message.length < 48) {
								FailureToast('Message too short');
								return;
							}
							setLoading(true);
							try {
								await firestore.collection('feedback').add({
									name,
									phone,
									feedbackType,
									message,
								});
								SuccessToast('Thanks for the feedback');
								resetForm();
								setLoading(false);
							} catch (error) {
								setLoading(false);
								FailureToast('Failed to submit feedback');
							}
						}}
						loading={loading}
					/>
				</View>
			</SafeAreaView>
		</KeyboardAvoidingView>
	);
}

const styles = StyleSheet.create({
	checkbox: {
		borderWidth: 0,
		backgroundColor: '#00000000',
	},
	inner: {
		padding: 24,
		flex: 1,
		justifyContent: 'space-around',
	},
});
